import React from "react";
import TranslateWithLinks from "../../Utility/TranslateWithLinks";
import { Tooltip } from "bitshares-ui-style-guide";
import counterpart from "counterpart";
export const HtlcRedeem = ({
  op,
  changeColor
}) => {
  changeColor("success");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "right-td"
  }, /*#__PURE__*/React.createElement(TranslateWithLinks, {
    string: "operation.htlc_redeem",
    keys: [{
      type: "account",
      value: op[1].redeemer,
      arg: "redeemer"
    }, {
      value: op[1].htlc_id,
      arg: "htlc_id"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: "memo",
    style: {
      paddingTop: 5,
      cursor: "help"
    }
  }, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "bottom",
    title: counterpart.translate("htlc.preimage_explanation")
  }, /*#__PURE__*/React.createElement("span", {
    className: "inline-block"
  }, counterpart.translate("htlc.preimage") + ": " + op[1].preimage))));
};